function setUser({ input, state }) {
  state.set('client.user', input.result.user)
}

export default setUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/setUser.js